import React, { useState } from "react";
import logo from "../../assets/images/inc-logo.svg";
import menu from "../../assets/images/menu.svg";
import { useHistory } from "react-router-dom";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { Card } from "react-bootstrap";
import { Badge as AntdBadge, Skeleton } from "antd";
import { offeredCandidateProfile } from "../../../src/pages/Profile/actions";
import { getItem } from "../../utils/Functions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const { Header, Sider } = Layout;
export default function Sidebar() {
  const dispatch = useDispatch();
  let candidateId = JSON.parse(getItem("User"))._id;
  const history = useHistory();

  const [collapsed, setCollapsed] = useState(false);
  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails
  );
  const [offerProfileData, setProfileCandidateData] = useState();
  const [offerProfileDatas, setOfferProfileDatas] = useState();

  useEffect(() => {
    dispatch(offeredCandidateProfile(candidateId));
  }, [candidateId]);

  useEffect(() => {
    if (offeredCandidateReduxData && offeredCandidateReduxData.status > 0) {
      setProfileCandidateData(offeredCandidateReduxData.unseenDocCount);
      setOfferProfileDatas(offeredCandidateReduxData.unseenSigningDocCount);
    }
  }, [offeredCandidateReduxData]);

  return (
    <>
      {/* <Layout>
        
      </Layout> */}

      <Layout className="candidate-sidebar">
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={(broken) => {
            console.log(broken);
          }}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
        >
          <Card className="card border-0 w-100">
            <Card.Header className="d-flex justify-content-between">
              <Card.Img src={logo} variant="top" className="logo-img" />
              {/* <Card.Img src={menu} variant="top" className="logo-img" /> */}
            </Card.Header>
          </Card>
          <div className="logo" />
          <Menu
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={[
              {
                key: "1",
                icon: <i className="bx bxs-file-doc"></i>,
                label: (
                  <div>
                    My Document
                    <AntdBadge count={offerProfileData} />
                  </div>
                ),
                onClick: () => {
                  history.push("/document");
                },
              },
              {
                key: "2",
                icon: <i className="bx bxs-error-alt"></i>,
                label: (
                  <div>
                    My Agreements
                    <AntdBadge count={offerProfileDatas} />
                  </div>
                ),

                onClick: () => {
                  history.push("/agreement");
                },
              },
            ]}
          />
        </Sider>
      </Layout>
    </>
  );
}